import { KontoausgleichHinzufügen } from '@/domain/mitarbeiter/features/feiertagskonto';
import { FeiertagskontoContentMobile } from '@/domain/mitarbeiter/features/feiertagskonto/FeiertagskontoContentMobile';
import { FeiertagskontoActive } from '@/domain/mitarbeiter/pages/feiertagskonto/overview/FeiertagskontoActive';
import { FeiertagskontoDeactive } from '@/domain/mitarbeiter/pages/feiertagskonto/overview/FeiertagskontoDeactive';

export function MobilePage({
  isActive,
  handleChange,
}: {
  isActive: boolean;
  handleChange: () => Promise<void>;
}) {
  return (
    <div>
      {isActive ? (
        <div className="">
          <div className="flex flex-col gap-8">
            <FeiertagskontoContentMobile />
            <FeiertagskontoActive handleChange={handleChange} />
          </div>
          <div className="fixed bottom-8 p-4 w-full flex items-center justify-between">
            <div className="fixed right-4 pointer-events-auto">
              <KontoausgleichHinzufügen />
            </div>
          </div>
        </div>
      ) : (
        <FeiertagskontoDeactive handleChange={handleChange} />
      )}
    </div>
  );
}
